// Pure constants — no "use client" directive so both Server and Client components can import freely.

export const SUPPORTED_LANGS = ["fr", "en"];
export const DEFAULT_LANG = "fr";

// Prefix applied to each lang for URLs: "fr" (default) → no prefix, "en" → /en
export const LANG_PREFIX = { fr: "", en: "/en" };

// <html lang="..."> values
export const HTML_LANG = { fr: "fr-FR", en: "en" };

// hreflang alternate values
export const CANONICAL_LANGS = { fr: "fr-FR", en: "en" };

// Display names
export const LANG_NAMES = { fr: "Français", en: "English" };
